import React from "react";
import "../styles/AppDownloadSection.css";
import GooglePlayImage from "../assets/googlePlay.png";
import AppStoreImage from "../assets/appStore.png";
import Phone1Image from "../assets/iphone.jpg";
import DogAndCatImage from "../assets/dogAndCat.png";
import CatHandImage from "../assets/catHands.png";
import PawPrintImage from "../assets/white paws.png";
import bonesVertical from "../assets/bones vertical.png";
import centerPaws from "../assets/center paws.png";
import centerPawsRight from "../assets/paw right.png";
import centerPawsLeft from "../assets/paw left.png";

const AppDownloadSection = () => {
  return (
    <section className="app-download-section">
      <img
        src={Phone1Image}
        alt="Cat and dog cuddling"
        className="banner-image"
      />

      {/* Decorative Paw Prints */}
      <img
        src={bonesVertical}
        alt="Paw Print"
        className="bones-vertical top-left"
      />
      <img
        src={PawPrintImage}
        alt="Paw Print"
        className="paw-print top-right"
      />
      <img src={centerPaws} alt="Paw Print" className="paw-print center" />
      <img
        src={centerPawsRight}
        alt="Paw Print"
        className="paw-print center-right"
      />
      <img
        src={centerPawsLeft}
        alt="Paw Print"
        className="paw-print center-left"
      />

      {/* Main Content */}
      <div className="app-download-content">
        <div className="app-links">
          <a
            href="https://play.google.com/store/apps/details?id=com.neon.furreverapp"
            target="_blank"
          >
            <img
              className="cursor-pointer"
              src={GooglePlayImage}
              alt="Get it on Google Play"
            />
          </a>
          <a
            href="https://apps.apple.com/eg/app/onefurever/id6741108135"
            target="_blank"
          >
            <img
              className="cursor-pointer"
              src={AppStoreImage}
              alt="Download on the App Store"
            />
          </a>
        </div>
      </div>

      {/* Bottom Decorations */}
      <img
        src={PawPrintImage}
        alt="Paw Print"
        className="paw-print bottom-right"
      />

      <img
        src={DogAndCatImage}
        alt="Dog and Cat"
        className="decorative-image-dog dog-cat"
      />
      <img
        src={CatHandImage}
        alt="Cat Hand"
        className="decorative-image cat-hand"
      />
    </section>
  );
};

export default AppDownloadSection;
